const S3 = (process.env.REACT_APP_S3_PATH || '').trim();

/** Local fallback when a category has no uploaded icon (served from public/img). */
export const LOCAL_DEFAULT_CATEGORY_ICON_PATH = `${(process.env.PUBLIC_URL || '').replace(/\/+$/, '')}/img/ALL.png`;

export function joinPublicAssetUrl(base, pathOrFilename) {
  if (!pathOrFilename) return '';
  const s = String(pathOrFilename).trim();
  if (/^https?:\/\//i.test(s)) return s;
  const b = base.replace(/\/+$/, '');
  if (!b) return '';
  const rel = s.replace(/^\/+/, '');
  const joined = `${b}/${rel.split('/').map((seg) => encodeURIComponent(seg)).join('/')}`;
  return joined.replace(/%2F/g, '/');
}

/** Same URL rules as the game scene (`game.jsx` s3Url). */
export function s3ThemeAssetUrl(filename) {
  return joinPublicAssetUrl(S3, filename);
}

/**
 * Category icon URL: uploaded theme assets go to S3; missing / "ALL.png"
 * placeholders use the local public file (ALL.png is not on S3).
 */
export function categoryIconUrl(icon) {
  const v = String(icon || '').trim();
  if (!v || v === 'ALL.png') return LOCAL_DEFAULT_CATEGORY_ICON_PATH;
  return s3ThemeAssetUrl(v);
}
